import { getKeyboardFocusableElements, getElementFromEvent } from '../utils';
import scrollLock from 'scroll-lock';
import VideoPlayer from "../components/VideoPlayer";

export default class Modal {
	constructor(container, collectionEl) {

		this.collectionEl = collectionEl;
		this.modal = container.querySelector('[data-modal]');
		this.closeButton = this.modal.querySelector('[data-modal-close]');
		this.modalContainer = this.modal.querySelector('[data-modal-wrapper]');
		this.modalOuter = this.modal.querySelector('[data-modal-outer]');

		collectionEl.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			const button = e.target?.closest('[data-open-modal]');

			if (!button) {
				return;
			}

			const collectionItem = e.target?.closest('[data-collection-item]');
			this.backgroundColor = button.dataset.backgroundColor;
			const script = collectionItem.querySelector('script[type="text/template"]');

			if (!script) {
				return;
			}

			this.openModal(script.innerHTML);
		});


		// Event listeners
		this.boundHandleKeys = this.handleKeys.bind(this);

		this.closeButton.addEventListener('click', (e) => {
			this.closeModal();
		});

		this.modal.addEventListener('click', (e) => {
			const isInside = getElementFromEvent(e, '.c-modal__inner');

			if (!isInside) {
				this.closeModal();
				return;
			}
		});
	}

	playAudio() {
		if(!this.audio) {
			return;
		}

		this.audio.play();
	}

	pauseResetAudio() {
		if(!this.audio) {
			return;
		}

		this.audio.pause();
		this.audio.currentTime = 0; // Reset time
	}

	handleKeys(e) {
		if (e.key === 'Escape') {
			this.closeModal();
		}
	}

	openModal(content) {

		this.modalOuter.style.background = this.backgroundColor;

		const container = this.modal.querySelector('[data-role="container"]');
		container.innerHTML = ' ';

		// ScrollLock Disable
		document.dispatchEvent(new CustomEvent('disable-scroll', {
			detail: {
				scrollingElm: this.modalContainer,
			}
		}));

		this.modal.classList.add('is-active');

		container.innerHTML = content;

		container.querySelectorAll('[data-video-player]').forEach((el) => new VideoPlayer(el));
		this.audio = container.querySelector('[data-modal-audio]');

		document.addEventListener('keydown', this.boundHandleKeys);
	}

	closeModal() {
		// ScrollLock Enable
		setTimeout(() => {
			document.dispatchEvent(new CustomEvent('enable-scroll'));
		}, 500);

		this.modal.classList.remove('is-active');

		document.removeEventListener('keydown', this.boundHandleKeys);

		this.pauseResetAudio();
	}

	destroy() {
		document.removeEventListener('keydown', this.boundHandleKeys);
	}
}
